import { Box, Typography } from '@mui/material';
import { withTrademark } from '../../../../shared/lib/common/Tokenizer';
import { RING_MY_PHONE_INFO_MODAL } from '../../app/constants';
import { userDetailsWrapper } from '../../../../shared/lib/theme/styleConstants';

const bullets = [
  RING_MY_PHONE_INFO_MODAL.BULLET_1,
  RING_MY_PHONE_INFO_MODAL.BULLET_2,
  RING_MY_PHONE_INFO_MODAL.BULLET_3,
];

const RingMyPhoneInfo = () => (
  <Box sx={userDetailsWrapper}>
    {bullets.map((bullet, i) => (
      <Box key={i} display="flex" alignItems="flex-start" gap="8px" mb="16px">
        <Typography variant="body1" sx={{ flexShrink: 0 }}>•</Typography>
        <Typography variant="body1">{withTrademark(bullet)}</Typography>
      </Box>
    ))}
  </Box>
);

export default RingMyPhoneInfo;
